<template>
  <div
    class="flex shrink-0 items-center overflow-hidden rounded-lg bg-white ring-1 ring-inset ring-gray-300"
    :class="isLarge ? 'h-12' : 'h-9'"
  >
    <button
      type="button"
      :disabled="minusDisabled"
      class="flex shrink-0 items-center justify-center font-bold text-gray-900 transition-colors disabled:pointer-events-none disabled:text-gray-400"
      :class="isLarge ? 'h-12 w-8 text-base' : 'h-9 w-6 text-sm'"
      @click="$emit('minus')"
    >
      <Minus2Icon :class="isLarge ? 'size-4' : 'size-3'" />
    </button>
    <div
      class="flex shrink-0 items-center justify-center font-bold leading-5 text-gray-900"
      :class="[
        isLarge ? 'h-12 w-8 text-base' : 'h-9 w-6 text-sm',
        { 'text-gray-300': mutedCounter },
      ]"
    >
      {{ quantity }}
    </div>
    <button
      type="button"
      :disabled="plusDisabled"
      class="flex shrink-0 items-center justify-center font-bold text-gray-900 transition-colors disabled:pointer-events-none disabled:text-gray-400"
      :class="isLarge ? 'h-12 w-8 text-base' : 'h-9 w-6 text-sm'"
      @click="$emit('plus')"
    >
      <Plus2Icon :class="isLarge ? 'size-4' : 'size-3'" />
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Minus2Icon from '~/assets/svg/ui/minus-2.svg?component'
import Plus2Icon from '~/assets/svg/ui/plus-2.svg?component'

const props = defineProps({
  quantity: {
    type: Number,
    default: 1,
  },
  minusDisabled: {
    type: Boolean,
    default: false,
  },
  plusDisabled: {
    type: Boolean,
    default: false,
  },
  mutedCounter: {
    type: Boolean,
    default: false,
  },
  /** Figma: Medium 36px, Large 48px */
  size: {
    type: String,
    default: 'medium',
  },
})

defineEmits(['minus', 'plus'])

const isLarge = computed(() => props.size === 'large')
</script>
